export class StringExtensions {
    static toTitleCase(str) {
        return str.replace(/\w\S*/g, (txt) => {
                return this.upperCaseFirstLetter(txt);
            }
        );
    }

    static upperCaseFirstLetter(str: string) {
        return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
    }

    static titleWithIndex(title, element?, listOfElements?) {
        const titleCase = title.charAt(0).toUpperCase() + title.slice(1);

        if (element && listOfElements) {
            if (element.id === null) {
                return titleCase + ' ' + (listOfElements.length > 0 ? listOfElements.length + 1 : '');
            }
            const itemIndex = listOfElements.findIndex(res => res.id === element.id);
            return titleCase + ' ' + (itemIndex > 0 ? (itemIndex + 1) : '');
        }
        return titleCase;
    }

}
